import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import router from "./router";
import api from "./services/api.service";
import i18n from "./i18n";
import "./components/generic";
import store from "./store";
import { SET_LANGUAGE } from "@/constants/mutations-type";

Vue.config.productionTip = false;
Vue.prototype.API = api;

new Vue({
  vuetify,
  router,
  i18n,
  store,
  computed: {
    isDesktop: (vm) => vm.$vuetify.breakpoint.mdAndUp,
  },
  mounted(){
    this.changeLang(store.state.config.lang)
  },
  methods: {
    toLogin() {
      if (this.$route.path !== "/") this.$router.push("/#login");
      this.$root.$emit("toLogin");
    },
    changeLang(lang) {
      store.commit(`config/${SET_LANGUAGE}`, lang);
    },
  },
  render: (h) => h(App),
}).$mount("#app");
